import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 28, className = "" }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
    className={className}
  >
    {children}
  </motion.div>
);

export const SectionHeader = ({ eyebrow, title, sub, testid }) => (
  <div className="mx-auto max-w-3xl text-center">
    {eyebrow && (
      <Reveal>
        <span className="eyebrow justify-center" data-testid={`${testid}-eyebrow`}>
          <span className="h-px w-8 bg-emerald-400/60" />
          {eyebrow}
          <span className="h-px w-8 bg-emerald-400/60" />
        </span>
      </Reveal>
    )}
    <Reveal delay={0.08}>
      <h2 className="mt-4 font-display text-3xl font-bold tracking-tight text-white sm:text-4xl lg:text-5xl">
        {title}
      </h2>
    </Reveal>
    {sub && (
      <Reveal delay={0.16}>
        <p className="mt-4 text-base leading-relaxed text-slate-400 sm:text-lg">{sub}</p>
      </Reveal>
    )}
  </div>
);

export default Reveal;
